<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 41 32"
  >
    <g>
      <path
        fill="#010F37"
        d="M37.71 0h-29.711c-0.001 0-0.001 0-0.002 0-1.893 0-3.427 1.534-3.427 3.427 0 0.001 0 0.002 0 0.002v-0 1.142h-1.14c-0.001 0-0.001 0-0.002 0-1.893 0-3.427 1.534-3.427 3.427v0 20.562c0 0.001 0 0.001 0 0.002 0 1.893 1.534 3.427 3.427 3.427 0.001 0 0.002 0 0.002 0h29.713c1.893 0 3.427-1.535 3.427-3.427 0-0.001 0-0.002 0-0.002v0-1.142h1.14c0.001 0 0.001 0 0.002 0 1.893 0 3.427-1.535 3.427-3.427v0-20.562c0-0.001 0-0.001 0-0.002 0-1.893-1.535-3.427-3.427-3.427-0.001 0-0.002 0-0.002 0h0zM34.285 28.561c-0.001 0.63-0.512 1.141-1.142 1.142h-29.713c-0.63-0.001-1.141-0.512-1.142-1.142v-20.562c0.001-0.63 0.512-1.141 1.142-1.142h1.143v17.144c0 1.893 1.534 3.427 3.427 3.427 0.001 0 0.002 0 0.002 0h26.285zM38.857 23.989c-0.001 0.63-0.512 1.141-1.142 1.142h-29.715c-0.63-0.001-1.141-0.512-1.142-1.142v-20.56c0.001-0.63 0.512-1.141 1.142-1.142h29.711c0.63 0.001 1.141 0.512 1.142 1.142v0zM12.572 12c2.21 0 4.001-1.791 4.001-4.001s-1.791-4.001-4.001-4.001c-2.21 0-4.001 1.791-4.001 4.001v0c0 2.21 1.791 4.001 4.001 4.001v0zM12.572 6.286c0.946 0 1.714 0.767 1.714 1.714s-0.767 1.714-1.714 1.714c-0.946 0-1.714-0.767-1.714-1.714v0c0.001-0.946 0.768-1.712 1.714-1.714h0zM29.784 7.93c-0.31-0.31-0.738-0.502-1.212-0.502s-0.902 0.192-1.212 0.502v0l-6.79 6.797-2.216-2.231c-0.31-0.31-0.738-0.502-1.212-0.502s-0.902 0.192-1.212 0.502l-6.288 6.292c-0.31 0.31-0.502 0.738-0.502 1.212v0 2.008c0 0.473 0.384 0.857 0.857 0.857v0h25.714c0.473 0 0.857-0.384 0.857-0.857v0-6.58c-0-0.473-0.192-0.902-0.502-1.212v0zM34.287 20.571h-22.858v-0.335l5.715-5.715 3.43 3.43 7.988-7.999 5.715 5.715z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
